import { graphql } from "relay-runtime"

export const chMarkPatientAsPotentialDuplicateMutation = graphql`
  mutation chMarkPatientAsPotentialDuplicateMutation($input: Ch_markPatientAsPotentialDuplicateInput!) {
    markPatientAsPotentialDuplicate: ch_markPatientAsPotentialDuplicate(input: $input) {
      boolean
      errors {
        __typename
        ... on Error {
          message
        }
      }
    }
  }
`
